import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import requestForToken from "../../notification/requestPermission";
import { useForm } from "react-hook-form";
import { LoginUser } from "../../actions/authActions";
import { useAuth } from "../../context/authContext";
import textWeight from "../../utils/textWeight";

export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [fcmToken, setFcmToken] = useState("sfsfs");
  const { TextWeight } = textWeight();
  const fetchToken = async () => {
    try {
      let token = await requestForToken();
      if (!token) {
        console.warn("FCM token not available, retrying...");
        await new Promise((resolve) => setTimeout(resolve, 2000)); // Wait and retry
        token = await requestForToken();
      }

      if (token) {
        setFcmToken(token);
        return token;
      } else {
        console.error("FCM token still unavailable. Setting fallback token.");
        setFcmToken("sfsfs"); // Fallback
        return "sfsfs";
      }
    } catch (error) {
      console.error("Error fetching FCM token:", error);
      setFcmToken("sfsfs");
      return "sfsfs";
    }
  };

  useEffect(() => {
    fetchToken();
  }, []);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const mutation = LoginUser(setLoadingToapi, location, login, navigate);
  const onSubmit = (data) => {
    setLoadingToapi(true);
    if (fcmToken) {
      mutation.mutate({
        email: data.email,
        password: data.password,
        fcmToken: fcmToken,
      });
    }
  };

  return {
    navigate,
    loadingToapi,
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    TextWeight,
  };
};
